<template>
  <el-row class="main_home">
    <TsaPendingPaymentTip type="home"></TsaPendingPaymentTip>
    <div class="main_home_bottom">
      <el-col :span="18" class="main_left">
        <div class="topInfo cardStyle">
          <div class="topTitle">从场景中获取灵感 <p class="choseExcellent">精选</p></div>
          <div class="cardList">
            <div class="cardItem"
                v-for="(item,index) in topInfo.cardList"
                :key="index"
                :class="{ activeClass: showIndex === index }"
                @mouseleave="showIndex = null"
            >
              <template>
                <div class="cardTop">
                  <div class="cardLeft"><img :src="item.img"/></div>
                  <div class="cardRight">
                    <div class="cardTitle">{{ item.title }}</div>
                    <!--                  <div class="cardNum">-->
                    <!--                    <i class="el-icon-view"></i>-->
                    <!--                    {{ item.num }}-->
                    <!--                  </div>-->
                  </div>
                </div>
                <div class="cardBtn">
                  <div @click="topClick(item.url,item,'解决方案',1)">解决方案</div>
                  <div class="useBtn"
                      @mouseover="showIndex = index "
                      @click="topClick(item.url2,item,'立即使用',2)"
                  >立即使用
                  </div>
                  <div class="layer-wrap" v-if="index<=1">
                    <dl>
                      <dt>
                        <p>下载权利卫士App</p>
                        <p>即刻取证</p>
                      </dt>
                      <dd>
                        <img src="https://tsa-content.oss-cn-beijing.aliyuncs.com/qlws/qlwsproductA.png">
                      </dd>
                    </dl>
                  </div>
                </div>
              </template>

            </div>
          </div>
        </div>
        <div class="midInfo cardStyle">
          <div class="topTitle">快捷入口
            <div class="titleRight" @click="midAllClick()">
              <p>查看全部产品</p>
              <!--            <img src="@/assets/images/newHome/rightIcon.png" alt="">-->
              <i class="el-icon-ali-jiantou"></i>

            </div>
          </div>
          <div class="cardList">
            <div class="cardItem" v-for="(item,index) in midInfo.cardList" :key="index">
              <div class="cardTitle">{{ item.title }}</div>
              <div class="cardMes">
                <div class="cardMesItem"
                    v-for="(item2,index2) in item.list"
                    :key="index2"
                    :style="{backgroundColor:item2.bc}"
                    @click="midCardClick(item,item2)"
                >
                  <img :src="item2.img"/>
                  <p>{{ item2.text }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="botInfo cardStyle">
          <div class="botColuwn">
            <p class="panTitle" @click="toPan('975260')">证据管理 <i class="el-icon-ali-jiantou"></i></p>

            <el-tabs v-model="botInfo.activeTabName" class="botTabs" @tab-click="handleTabClick">
              <el-tab-pane label="权利卫士" name="qlws">
                <ExTable
                    :table-list="botInfo.tableData1"
                    :isIndex="false"
                    :isBorder="false"
                    :header="botInfo.header1"
                    height="300"
                    :total="botInfo.total"
                    :tableId="0"
                    :activeIndex="botInfo.page"
                    :pageSizeNum="botInfo.pageSizeNum"
                    v-loading="tableLoading"
                >
                  <el-table-column slot="operate" label="操作" align="center" width="120">
                    <template slot-scope="scope">
                      <el-button type="text" @click="tableMes(scope.row,botInfo.activeTabName)">详情
                      </el-button>
                    </template>
                  </el-table-column>
                </ExTable>
              </el-tab-pane>
              <el-tab-pane label="电子证据平台" name="evidence">
                <ExTable
                    :table-list="botInfo.tableData2"
                    :isIndex="false"
                    :isBorder="false"
                    :header="botInfo.header2"
                    height="300"
                    :total="botInfo.total"
                    :tableId="1"
                    :activeIndex="botInfo.page"
                    :pageSizeNum="botInfo.pageSizeNum"
                    v-loading="tableLoading"

                >
                  <el-table-column slot="operate" label="操作" align="center" width="120">
                    <template slot-scope="scope">
                      <el-button type="text" @click="tableMes(scope.row,botInfo.activeTabName)">详情
                      </el-button>
                    </template>
                  </el-table-column>
                </ExTable>
              </el-tab-pane>
              <el-tab-pane label="知识产权平台" name="opus">
                <ExTable
                    :table-list="botInfo.tableData3"
                    :isIndex="false"
                    :isBorder="false"
                    :header="botInfo.header3"
                    height="300"
                    :total="botInfo.total"
                    :tableId="2"
                    :activeIndex="botInfo.page"
                    :pageSizeNum="botInfo.pageSizeNum"
                    v-loading="tableLoading"

                >
                  <el-table-column
                      slot="storeType"
                      label="认证方式"
                      align="center"
                      width="140"
                      class="storeType"
                  >
                    <template slot-scope="scope">
                      <div class="storeSize">
                        <span>{{ scope.row.storeType == 0 ? '脱敏认证' : '存证' }}</span>
                        <span class="fileSize"
                              v-if="scope.row.storeType!==0 && scope.row.applyFileSize">（{{
                            scope.row.applyFileSize | fileSize
                          }}）
                      </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                      slot="storeExpiredAt"
                      label="存储到期时间"
                      align="center"
                      width="150"
                      class="storeType"
                  >
                    <template slot-scope="scope">
                      <div class="expiredAtWrap">
                                      <span class="expiredAt" v-if="scope.row.storeExpiredAt && scope.row.storeType==1">
                                              <p>{{ scope.row.storeExpiredAt | formatDate3 }}</p>
                                      </span>
                        <span v-else>-</span>
                        <div v-if="scope.row.storeType==1" class="expiredType">
                          <div class="p" v-if="scope.row.expiredTagType==2">
                            <span class="red">已过期</span>
                          </div>
                          <div class="p" v-if="scope.row.expiredTagType==1">
                            <span class="orange">即将到期</span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column slot="operate" label="操作" align="center" width="120">
                    <template slot-scope="scope">
                      <el-button type="text" @click="tableMes(scope.row,botInfo.activeTabName)">详情
                      </el-button>
                    </template>
                  </el-table-column>
                </ExTable>
              </el-tab-pane>
              <el-tab-pane label="邮件认证平台" name="email" v-if="!isChildAcc">
                <ExTable
                    :table-list="botInfo.tableData4"
                    :isIndex="false"
                    :isBorder="false"
                    :header="botInfo.header4"
                    height="300"
                    :total="botInfo.total"
                    :tableId="3"
                    :activeIndex="botInfo.page"
                    :pageSizeNum="botInfo.pageSizeNum"
                    v-loading="tableLoading"

                >
                  <el-table-column
                      slot="fromName"
                      label="发件人"
                      align="center"
                      show-overflow-tooltip>
                    <template slot-scope="scope">
                      <p class="ellipsis block" v-if="scope.row.fromName">{{ scope.row.fromName }}<{{
                          scope.row.fromEmail
                        }}></p>
                      <p class="ellipsis block" v-else>{{ scope.row.fromEmail }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                      slot="storeType"
                      label="认证方式"
                      align="center"
                      width="100"
                      show-overflow-tooltip>
                    <template slot-scope="scope">
                      <p>{{ scope.row.applyType === 0 ? '脱敏' : scope.row.applyType === 1 ? '存证' : '-' }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                      slot="storeExpiredAt"
                      label="存储到期时间"
                      align="center"
                      width="150"
                      show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="StorageExpirationTime">
                        <p v-if="scope.row.storeExpiredAt" class="block"
                          :class="scope.row.storeExpired === 1 ? 'expire' : ''">
                          {{ scope.row.storeExpiredAt | formatDate3 }}</p>
                        <p v-else>-</p>
                        <el-tooltip class="item" effect="dark" content="存储已到期，请续费" placement="top"
                                    v-if="(scope.row.storeExpired === 1)">
                          <img src="@/assets/images/newHome/warn.png" alt="">
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column slot="operate" label="操作" align="center" width="120">
                    <template slot-scope="scope">
                      <el-button type="text"
                                v-if="(scope.row.applyType === 1)"
                                @click="tableMes(scope.row,botInfo.activeTabName)">详情
                      </el-button>
                    </template>
                  </el-table-column>
                </ExTable>
              </el-tab-pane>

            </el-tabs>
            <div class="botMore" @click="botAllClick(botInfo.activeTabName)" v-if="botInfo.tableData.length>0">查看更多证据
              <i class="el-icon-ali-jiantou"></i>
            </div>
          </div>
          <div class="whiteBox"></div>
        </div>
      </el-col>
      <el-col :span="6" class="main_right">
        <div class="main_center"></div>
        <div class="rightC">
          <div class="cardTop cardStyle">
            <div class="avatar ">
              <img :src="cardInfo.avatarImg" alt="" class="avatarImg" v-if="!isChildAcc ">
              <img :src="cardInfo.avatorChildBg" alt="" class="avatarImg" v-else>
              <div class="loginName">
                <div class="phone">{{ userInfo.loginName }}</div>
                <div class="lawyerClass" v-if="$getlocalStorage('userData').parentId === '0' ">
                  <img :src="cardInfo.authentedBg" alt="" class="lawyerBg"
                      v-if="![-1,3,5].includes(authenticationStatus) &&lawyerStatus!==1"/>
                  <img :src="cardInfo.authentBg" alt="" class="lawyerBg"
                      v-else-if="![-1,3,5].includes(authenticationStatus) &&lawyerStatus===1"/>
                  <img :src="cardInfo.toAuthentBg" alt=""
                      class="lawyerBg noAuthent"
                      @click="toAuthent()"
                      v-if="[-1,3,5].includes(authenticationStatus)"/>
                  <img :src="cardInfo.lawyerBg" alt="" class="lawyerBg isLawyer" v-if="lawyerStatus===1">
                </div>
              </div>
            </div>
            <div class="expense" :class="isChildAcc ? 'childExpense' : ''">
              <div v-if="$getlocalStorage('userData').parentId === '0'">
                <p>时间戳余额</p>
                <div class="num">{{ accountInfo.generalTsCount || 0 }}</div>
              </div>
              <div v-else class="childEls">
                <div class="balance parent">
                  <p><b>{{ accountInfo.generalTsCount || 0 }}</b><span>主账号通用时间戳</span></p>
                </div>
                <div class="balance use">
                  <p><b>{{ accountInfo.currentConsumeTsCount || 0 }}</b><span>已用时间戳</span></p>
                </div>
                <div class="balance current">
                  <p><b>{{
                      accountInfo.consumeLimitTsCount === -1 ? '无限制' : accountInfo.consumeLimitTsCount
                    }}</b><span>最大使用限制数</span></p>
                </div>
              </div>
              <div class="btnBuy" @click="cardTopBuy()" v-if="!isChildAcc">去充值</div>
            </div>
            <div class="expenseLog botMore" @click="cardTopExpense()">
              消费记录
              <i class="el-icon-ali-jiantou"></i>
            </div>
          </div>
          <div class="userSet cardStyle" v-if="!isChildAcc">
            <div class="userTitle">{{ cardInfo.titleText }}</div>
            <div class="serviceSet">
              <div class="package">
                <PackageTypeList ref="packageTypeList" @titleText="titleText" @serviceBuy="serviceBuy"/>
              </div>
            </div>
          </div>
          <div class="adBanner cardStyle">
            <a :href="cardInfo.adBnner.hrefPath" :target="cardInfo.adBnner.openType===0?'_blank':'_self'"
              @click="bannerClick">
              <img :src="cardInfo.adBnner.filePath" alt=""></img>
            </a>
          </div>
        </div>
      </el-col>
    </div>
  </el-row>
</template>

<script>
import {formatDate, fileSize} from "@/utils/filter";
import ExTable from "@com/ExTable";
import {bannerList} from '@http/common/index.js'
import {overviewNum, overviewChildNum} from "@http/overview/index";
import {eviList, qlwsList, opusList, emailList, currentTime} from '@http/platformHome'
import {identification} from "@http/user_center/userInfo";
import {getLawyerStatus} from '@/http/modules/lawcase'
import {formatDate3} from "../utils/filter";
import PackageTypeList from '@/views/layout/components/packageTypeList'
import TsaPendingPaymentTip from '@/components/pendingPaymentTip'

const bc1 = '#FAF9F5'
const bc2 = '#EEFAFA'
const bc3 = '#FBF6F7'
const bc4 = '#FAF6FF'
const bc5 = '#EFF8FF'
export default {
  data() {
    return {
      topInfo: {
        cardList: [
          {
            title: '聊天记录取证',
            num: 0,
            img: require('@/assets/images/newHome/tr1.png'),
            url: process.env.VUE_APP_TSA + '/template/weixinjiluquzheng.html',
            url2: process.env.VUE_APP_TSA + '/quanliweishi.html',
            isQlws: true,
          },
          {
            title: '网络暴力取证',
            num: 0,
            img: require('@/assets/images/newHome/tr4.png'),
            url: process.env.VUE_APP_TSA + '/template/wangluobaoliquzheng.html',
            url2: process.env.VUE_APP_TSA + '/quanliweishi.html',
            isQlws: true,
          },
          {
            title: '原创内容保护',
            num: 0,
            img: require('@/assets/images/newHome/tr2.png'),
            url: process.env.VUE_APP_TSA + '/template/yuanchuangneirongbaohu.html',
            url2: process.env.VUE_APP_COPYRIGHT + '/system/index/copyright',

          },
          {
            title: '商业秘密保护',
            num: 0,
            img: require('@/assets/images/newHome/tr3.png'),
            url: process.env.VUE_APP_TSA + '/template/shangyemimibaohu.html',
            url2: process.env.VUE_APP_COPYRIGHT + '/system/index/tradeSecret',

          },

        ]
      },
      midInfo: {
        cardList: [
          {
            title: '热门取证工具',
            baseUrl: process.env.VUE_APP_EV,
            list: [
              {
                img: require('@/assets/images/newHome/mr1.png'),
                text: '录屏取证',
                bc: bc1,
                url: process.env.VUE_APP_EV + '/vm_fetch',
              },

              {
                img: require('@/assets/images/newHome/mr2.png'),
                text: '境外取证',
                bc: bc2,
                url: process.env.VUE_APP_EV + '/overseas',

              },
              {
                img: require('@/assets/images/newHome/mr3.png'),
                text: '网页取证',
                bc: bc3,
                url: process.env.VUE_APP_EV + '/evidence/simple',

              }
            ],
          },
          {
            title: '知识产权保护',
            baseUrl: process.env.VUE_APP_COPYRIGHT,
            list: [
              {
                img: require('@/assets/images/newHome/mr4.png'),
                text: '版权保护',
                bc: bc4,
                url: process.env.VUE_APP_COPYRIGHT + '/system/index/copyright',

              },
              {
                img: require('@/assets/images/newHome/mr5.png'),
                text: 'AI作品认证',
                bc: bc2,
                url: process.env.VUE_APP_COPYRIGHT + '/time/Aigc',

              },
              {
                img: require('@/assets/images/newHome/mr6.png'),
                text: '数据知识产权存证',
                bc: bc3,
                url: process.env.VUE_APP_COPYRIGHT + '/system/index/singleCert',

              }
            ],
          },
          {
            title: '认证与签署',
            baseUrl: process.env.VUE_APP_EMAIL,
            baseUrl2: process.env.VUE_APP_SIGN,
            isSign: true,
            list: [
              {
                img: require('@/assets/images/newHome/mr7.png'),
                text: '邮件认证',
                bc: bc5,
                url: process.env.VUE_APP_EMAIL + '/emailProof/witnessEmail',
              },
              {
                img: require('@/assets/images/newHome/mr8.png'),
                text: 'PDF认证',
                bc: bc4,
                url: process.env.VUE_APP_TSA + '/template/pdf.html',
              },
              {
                img: require('@/assets/images/newHome/mr9.png'),
                text: '电子合同签署',
                bc: bc1,
                url: process.env.VUE_APP_SIGN + '/logged/index',

              }
            ],
          },
          {
            title: '开放平台',
            baseUrl: process.env.VUE_APP_TSA,
            list: [
              {
                img: require('@/assets/images/newHome/mr10.png'),
                text: '可信时间戳接口',
                bc: bc2,
                url: process.env.VUE_APP_TSA + '/openservice.html?type=0',

              },
              {
                img: require('@/assets/images/newHome/mr11.png'),
                text: '电子取证接口',
                bc: bc5,
                url: process.env.VUE_APP_TSA + '/openservice.html?type=1',

              },
              {
                img: require('@/assets/images/newHome/mr12.png'),
                text: '版权保护接口',
                bc: bc1,
                url: process.env.VUE_APP_TSA + '/openservice.html?type=2',

              }
            ],
          },
        ]
      },
      botInfo: {
        activeTabName: 'qlws',
        header1: [
          {
            prop: "evidenceName",
            label: "证据名称",
          },
          {
            prop: "remarkName",
            label: "自定义名称",
          },
          {
            prop: "evidenceTypeName",
            label: "证据类型",
          },
          {
            prop: "applyAt",
            label: "取证时间",
            formatter: (row) => {
              return formatDate(row.applyAt);
            },
          },
          // {
          //   prop: "remark",
          //   label: "备注",
          // },
          {
            prop: "applyAccount",
            label: "取证账号",
          },
          {
            minWidth: 40,
            slot: 'operate'
          }
        ],
        header2: [
          {
            prop: "name",
            label: "证据名称",
          },
          {
            prop: "evType",
            label: "使用功能",
          },
          {
            prop: "tsaAt",
            label: "取证时间",
            formatter: (row) => {
              return formatDate(row.tsaAt);
            },
          },
          // {
          //   prop: "remark",
          //   label: "备注",
          // },
          {
            prop: "applicantAccount",
            label: "取证账号",
          },
          {
            prop: "evidenceTabStatusName",
            label: "取证状态",
          },
          {
            minWidth: 40,
            slot: 'operate'
          }
        ],
        header3: [
          {
            prop: "opusName",
            label: "文件名称",
          },
          {
            prop: "fileTypeName",
            label: "文件类型",
          },
          {
            prop: "operatedAt ",
            label: "签发时间",
            formatter: (row) => {
              return formatDate(row.operatedAt);
            },
          },
          {
            slot: "storeType"
          },
          {
            prop: "applyAccount",
            label: "申请账号",
          },
          {
            slot: "storeExpiredAt"
          },
          // {
          //   prop: "storeExpiredAt",
          //   label: "存储到期时间",
          //   formatter: (row) => {
          //     return formatDate(row.storeExpiredAt);
          //   },
          // },

          // {
          //   prop: "applyRemark",
          //   label: "备注",
          // },
          {
            minWidth: 40,
            slot: 'operate'
          }
        ],
        header4: [
          {
            prop: "subject",
            label: "主题",
          },
          {
            slot: "fromName"
          },
          {
            prop: "emailTo",
            label: "收件人",
          },
          {
            slot: "storeType"
          },
          {
            prop: "sendAt ",
            label: "发件时间",
            width: "180",
            formatter: (row) => {
              return formatDate(row.sendAt);
            },
          },
          {
            slot: "storeExpiredAt"
          },
          {
            minWidth: 40,
            slot: 'operate'
          }
        ],
        total: 0,
        page: 1,
        pageSizeNum: 5,
        tableData1: [],
        tableData2: [],
        tableData3: [],
        tableData4: [],
        tableData: [],
      },
      cardInfo: {
        avatarImg: require('@/assets/images/newHome/avator.png'),
        avatorChildBg: require('@/assets/images/newHome/avatorChild.png'),
        lawyerBg: require('@/assets/images/newHome/lawyer.png'),
        authentedBg: require('@/assets/images/newHome/authented.png'),
        authentBg: require('@/assets/images/newHome/authent.png'),
        toAuthentBg: require('@/assets/images/newHome/toAuthent.png'),
        userInfo: {},
        titleImg: require('@/assets/images/newHome/ac1.png'),
        adBnner: "",
        serviceList: [],
        titleText: ''
      },
      accountInfo: {},
      isChildAcc: false,
      authenticationStatus: '',
      tableLoading: false,
      lawyerStatus: '',
      requestFlag: 0,
      showIndex: null,
      chooseId: "",
      suitesList: [],
    };
  },
  mixins: [],
  components: {
    ExTable,
    PackageTypeList,
    TsaPendingPaymentTip
  },
  filters: {
    fileSize,
  },
  computed: {
    channelCodeValue() {
      return this.$store.state.config.channelCodeValue;
    },
    userInfo: {
      get() {
        return this.$store.state.userInfo.userinfo;
      },
      set(val) {
        this.$store.state.userInfo.userinfo = val;
      },
    },
  },

  created() {
    this.getOverviewNum();
    this.getBanner();
    this.getTableData('qlws');
  },

  mounted() {
    zhuge.track('用户中心_进入工作台', {
      '渠道': this.channelCodeValue,
    })
    this.$refs.packageTypeList.dealListCommon()
  },
  methods: {
    formatDate3,
    // 顶部场景跳转
    topClick(data, item, text, type) {
      if (type === 1 || (!item.isQlws && type === 2)) {
        window.open(data);
        zhuge.track('用户中心_工作台精选场景', {
          '渠道': this.channelCodeValue,
          '按钮名称': text,
          '解决方案名称': item.title,
        })
      }


    },

    // mid查看更多
    midAllClick() {
      zhuge.track('用户中心_工作台快捷入口', {
        '渠道': this.channelCodeValue,
        '功能名称': '查看全部产品',
      })
      window.open(process.env.VUE_APP_TSA + '?codeParams=product');
    },

    // midCard跳转
    midCardClick(item, item2) {
      zhuge.track('用户中心_工作台快捷入口', {
        '渠道': this.channelCodeValue,
        '功能名称': item2.text,
        '所属类别': item.title,
      })
      window.open(item2.url);
    },

    // 底部列表操作
    tableMes(row, type) {
      let zhugeText
      switch (type) {
        case 'qlws':
          window.open(process.env.VUE_APP_EV + '/qlws' + '?evidenceType=' + row.evidenceType + '&id=' + row.id);
          zhugeText = '权利卫士'
          break
        case 'evidence':
          zhugeText = '电子证据平台'
          const {evCode} = row
          let childUrl =
              evCode === '1' ? '/evidence/simple' :
                  evCode === '2' ? '/selenoid' :
                      evCode === '3' ? '/vm_fetch' :
                          evCode === '4' ? '/overseas' :
                              evCode === '5' ? '/autoMatic/video' :
                                  evCode === '6' ? '/autoMatic/live' :
                                      evCode === '8' ? '/autoMatic/wxauto' :
                                          ''
          window.open(process.env.VUE_APP_EV + childUrl + '?id=' + row.id);
          break
        case 'opus':
          zhugeText = '知识产权平台'
          window.open(process.env.VUE_APP_COPYRIGHT + '/time/FileDetail' + '?serialNo=' + row.serialNo);
          break
        case 'email':
          zhugeText = '邮件认证平台'
          window.open(process.env.VUE_APP_EMAIL + '/emailProof/witnessEmailDetail' + '?serialNo=' + row.serialNo);
          break
      }
      zhuge.track('用户中心_工作台查看证据', {
        '渠道': this.channelCodeValue,
        '按钮名称': '详情',
        '产品名称': zhugeText,
      })
    },

    // 右侧顶部充值
    cardTopBuy() {
      zhuge.track('用户中心_工作台右侧个人信息区', {
        '渠道': this.channelCodeValue,
        '按钮名称': '去充值',
      })
      this.$router.push({path: '/userAccount/buy'})
    },

    // 消费记录
    cardTopExpense() {
      zhuge.track('用户中心_工作台右侧个人信息区', {
        '渠道': this.channelCodeValue,
        '按钮名称': '消费记录',
      })
      this.$router.push({path: '/userAccount/state'})
    },

    // 右侧服务包购买
    serviceBuy(item) {
      this.$router.push({path: '/userAccount/buy', query: {suiteId: item.id}})
      zhuge.track('用户中心_工作台购买套餐', {
        '渠道': this.channelCodeValue,
      })
    },

    // adBanner获取
    getBanner() {
      bannerList().then((res) => {
        this.cardInfo.adBnner = (res instanceof Array && res.length > 0) ? res[0] : {};
      })
    },

    // adBanner跳转
    bannerClick(e) {
      e.preventDefault();
      zhuge.track('用户中心_工作台运营广告位', {'渠道': this.channelCodeValue,}, () => {
        if (this.cardInfo.adBnner.openType === 0) {
          window.open(this.cardInfo.adBnner.hrefPath);
        } else {
          window.location.href = this.cardInfo.adBnner.hrefPath;
        }
      })
      return false;
    },

    // 获取时间戳
    async getOverviewNum() {
      if (this.$getlocalStorage('userData').parentId == '0') {
        this.accountInfo = await overviewNum({});
        this.isChildAcc = false
      } else {
        this.accountInfo = await overviewChildNum({});
        this.isChildAcc = true
      }
      identification({hiddenApproval: true}).then((res) => {
        this.authenticationStatus = res.authenticationStatus;
      }).catch((err) => {
        console.log(err);
      });
      getLawyerStatus().then(res => {
        this.lawyerStatus = res.status;
      }).catch(err => {
        console.log(err)
      })
      currentTime().then(res => {
        this.topInfo.cardList.forEach((item, index) => {
          let numIdx =
              index === 0 ? 1749018421134 :
                  index === 1 ? 1749018414134 :
                      index === 2 ? 1749018435134 :
                          index === 3 ? 1749018466134 :
                              ''
          item.num = 9999 + Math.ceil((res.timestamp - numIdx) / 9999)
        })
      })
    },

    // 底部数据
    getTableData(type) {
      this.botInfo.tableData1 = []
      this.botInfo.tableData2 = []
      this.botInfo.tableData3 = []
      this.botInfo.tableData4 = []
      this.tableLoading = true
      switch (type) {
        case 'qlws':
          qlwsList({size: 5}).then(res => {
            if(res && res.length>0){
              this.botInfo.tableData1 = res;
              this.botInfo.tableData = res;
            }
            this.tableLoading = false
          }).catch(err => {
            console.log(err)
          })
          break
        case 'evidence':
          eviList({page: 1, size: 5, tabIdx: 1}).then(res => {
            this.botInfo.tableData2 = res;
            this.botInfo.tableData = res;
            this.tableLoading = false
          })
          break
        case 'opus':
          opusList({page: 1, size: 5}).then(res => {
            this.botInfo.tableData3 = res.data;
            this.botInfo.tableData = res.data;
            this.tableLoading = false

          })
          break
        case 'email':
          emailList({page: 1, size: 5, applyStatus: 4}).then(res => {
            this.botInfo.tableData4 = res.data;
            this.botInfo.tableData = res.data;
            this.tableLoading = false
          })
          break
      }
    },
    // tab切换
    handleTabClick() {
      this.getTableData(this.botInfo.activeTabName)
    },
    // 查看更多证据
    botAllClick(type) {
      let zhugeText
      switch (type) {

      }
      let sourceCode = type === 'qlws' ? '954210' :
          type === 'evidence' ? '955740' :
              type === 'opus' ? '952310' :
                  type === 'email' ? '700025' :
                      ''
      window.open(process.env.VUE_APP_PAN + '/allEvidence' + '?sourceType=' + sourceCode);
      zhuge.track('用户中心_工作台查看证据', {
        '渠道': this.channelCodeValue,
        '按钮名称': '查看更多证据',
        '产品名称': zhugeText,
      })
    },
    // 实名认证
    toAuthent() {
      zhuge.track('用户中心_工作台右侧个人信息区', {
        '渠道': this.channelCodeValue,
        '按钮名称': '立即认证',
      })
      this.$router.push({path: '/userCenter/authenticationName'})
    },
    toPan(type) {
      window.open(process.env.VUE_APP_PAN+'/allEvidence?sourceType='+type)
    },
    titleText(data) {
      this.cardInfo.titleText = data
    }
  }

};
</script>
<style lang='less' scoped>
.main_home {
  padding: 10px;
  display: flex;
  flex-direction: column;
  .main_home_bottom {
    width: 100%;
  }
  .cardStyle {
    background: rgba(255, 255, 255, 0.7);
    box-shadow: 0 4px 20px 0 rgba(0, 71, 255, 0.1);
    border-radius: 16px 16px 16px 16px;
    border: 1px solid #FFFFFF;
  }

  .botMore {
    font-weight: bold;
    color: #333;
    font-size: 14px;
    text-align: center;
    margin-top: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 20px;
      margin-top: 3px;
    }

    &:hover {
      color: #0047FF;
    }
  }

  .choseExcellent {
    width: 32px;
    height: 18px;
    background: linear-gradient(132deg, #FF364D 0%, #FF8B68 100%);
    border-radius: 9px 12px 12px 0;
    font-size: 11px;
    font-weight: bold;
    text-align: center;
    line-height: 18px;
    display: inline-block;
    color: #fff;
    margin-left: 8px;
  }

  .main_left {
    display: flex;
    flex-direction: column;
    height: 100%;
    .topTitle {
      font-weight: bold;
      font-size: 18px;
      color: #000000;
      display: flex;
      align-items: center;
    }

    .topInfo {
      padding: 16px 20px;


      .cardList {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        margin-top: 20px;

        .cardItem {
          background: linear-gradient(132deg, rgba(241, 243, 255, .5) 0%, rgba(236, 246, 255, .5) 100%);
          border-radius: 16px 16px 16px 16px;
          padding: 20px 16px;
          flex: 1;
          margin-right: 11px;
          position: relative;

          &:last-child {
            margin-right: 0;
          }

          .cardTop {
            display: flex;
            align-items: center;

            .cardLeft {
              width: 40px;
              height: 40px;
              background: #FFFFFF;
              border-radius: 50%;
              text-align: center;
              line-height: 55px;

              img {
                width: 24px;
                height: 24px;
              }
            }

            .cardRight {
              margin-left: 8px;

              .cardTitle {
                font-weight: bold;
                font-size: 16px;
                color: #333;
              }

              .cardNum {
                font-size: 12px;
                color: #666;
                margin-top: 4px;
              }
            }
          }

          .cardBtn {
            text-align: center;
            display: flex;
            //font-weight: bold;
            font-size: 14px;
            color: #333333;
            margin-top: 16px;
            justify-content: center;

            div {
              border-radius: 16px 16px 16px 16px;
              border: 1px solid #dbe3f1;
              padding: 6px 11%;
              cursor: pointer;
              align-items: center;
              justify-content: center;

              &:nth-child(2) {
                margin-left: 12px;
                color: #0047FF;
                text-shadow: 0 0 4px #FFFFFF;
                background: #FFF;
                border: none;
                border: 1px solid #0047FF;

                &:hover {
                  background: #0047FF;
                  color: #fff;
                  text-shadow: none;
                }
              }

              &:nth-child(1) {
                &:hover {
                  border: 1px solid #0047FF;
                  color: #0047FF;
                }
              }
            }


          }

          .layer-wrap {
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
            backdrop-filter: blur(10px);
            border-radius: 16px;
            z-index: 9;
            box-sizing: border-box;
            transition: top .3s ease-in-out;

            dl {
              display: flex;
              align-items: center;
              justify-content: center;

              dt {
                margin-right: 16px;
                margin-left: -12px;

                p {
                  text-align: center;
                  color: #fff;
                  font-size: 14px;
                  font-weight: bold;
                  margin: 3px 0;
                }
              }

              dd {
                padding: 5px;
                background-color: #fff;
                border-radius: 16px;
                position: relative;

                img {
                  display: block;
                  width: 90px;
                  height: 90px;
                }
              }
            }

            &:hover {
              cursor: inherit;
            }
          }

          .cardBtn .useBtn:hover {
            cursor: pointer;
          }

        }

        .activeClass {
          .layer-wrap {
            display: flex;
          }
        }
      }
    }

    .midInfo {
      padding: 22px 16px;
      margin: 16px 0;

      .topTitle {
        display: flex;
        justify-content: space-between;

        .titleRight {
          font-size: 14px;
          cursor: pointer;
          display: flex;
          align-items: center;
          padding-right: 0px;

          p {
            display: inline-block;
            font-weight: bold;
          }

          i {
            font-size: 13px;
            float: right;
          }

          &:hover {
            color: #0047FF;
          }
        }
      }

      .cardList {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 21px 0 0 4px;

        .cardItem {
          width: 49%;

          .cardTitle {
            font-weight: bold;
            font-size: 14px;
            color: #000;
          }

          .cardMes {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;

            .cardMesItem {
              border-radius: 8px;
              background: #FAFAF5;
              font-size: 14px;
              color: #333333;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              margin: 12px 12px 16px 0;
              //width: 196px;
              height: 100px;
              padding: 0 5%;
              width: 33%;
              cursor: pointer;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;

              img {
                margin-bottom: 6px;
                width: 40px;
                height: 40px;
              }

              p {
                //font-weight: bold;
              }

              &:hover {
                p {
                  color: #0047FF;
                }
              }

              &:nth-child(3n) {
                margin-right: 4px;
              }
            }


          }
        }
      }
    }

    .botInfo {
      flex: 1;
      padding: 16px;
      .botColuwn {
        position: relative;

        .panTitle {
          position: absolute;
          right: 10px;
          top: 6px;
          cursor: pointer;
          z-index: 1;
          font-size: 16px;
          color: #181C1F;

          &:hover {
            color: #0047FF;
          }
        }
      }

      /deep/ .botTabs {
        background: rgba(255, 255, 255, 0.7);

        .el-tabs__header {
          margin: 0;

          .el-tabs__nav-wrap {
            &::after {
              display: none;
            }

            .el-tabs__nav-scroll {
              .el-tabs__active-bar {
                background-color: #0047FF;
              }

              .el-tabs__item.is-active {
                color: #0047FF;
                font-weight: bold;
              }

              .el-tabs__item {
                font-size: 16px;
                color: #181C1F;
                padding: 0 56px;
                height: 45px;

                &:hover {
                  color: #0047FF;
                }

                &:nth-child(2), &:nth-child(1) {
                  padding-left: 12px;
                }
              }
            }
          }
        }

        .el-table {
          &::before {
            content: none;
          }

          color: #666666;

          .el-button--text {
            color: #0047FF;
          }

          .el-table__cell {
            border-bottom: none;
          }

          .el-table__header {
            margin-top: 20px;

            thead {
              color: #333333;
              font-size: 14px;

              th {
                background: #F7F9FD;
              }

              .cell {
                font-weight: bold;

              }

            }


          }

          .el-table__row--striped {
            .el-table__cell {
              background: #FFF;
            }
          }
        }

        .page-block {
          display: none;
        }
      }
    }
  }

  .main_center {
    height: 100%;
    float: left;
  }

  .main_right {
    .rightC {
      margin-left: 16px;
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .cardTop {
      padding: 16px 16px 24px;
      margin: 0 0 16px 0;

      .avatar {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .avatarImg {
          width: 56px;
          height: 56px;
          border-radius: 50%;
        }

        .lawyerClass {
          display: flex;
          justify-content: center;
          margin-top: 12px;
          align-items: center;

          .lawyerBg {
            width: 48.8px;
            height: 19.4px;
            margin: -6px 0 0 0;
          }

          .noAuthent {
            width: 85.2px;
            height: 18px;
            cursor: pointer;
          }

          .isLawyer {
            margin-left: 4px;
            width: 62.8px;
            height: 18.4px;
          }

        }


        .phone {
          margin-top: 12px;
          font-weight: bold;
          font-size: 18px;
          color: #000;
          text-align: center;
        }
      }

      .avatarMin {
        display: none;
      }

      .expense {
        padding: 12px 24px;
        background: linear-gradient(132deg, #F7F0FF 0%, #ECF6FF 100%);
        border-radius: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 36px 0 24px 0;

        p {
          font-weight: bold;
          font-size: 14px;
          color: #000;
          float: left;
          line-height: 32px;
        }

        .num {
          font-weight: bold;
          font-size: 24px;
          color: #000;
          float: left;
          line-height: 32px;
          margin-left: 12px;
        }

        .btnBuy {
          background: #1A64E5;
          color: #fff;
          padding: 8px 15%;
          border-radius: 16px;
          display: inline-block;
          cursor: pointer;
          min-width: 36px;
        }
      }

      .childExpense {
        display: block;

        .childEls {
          display: flex;
          justify-content: space-between;

          .balance {
            p {
              display: flex;
              flex-direction: column;
              font-weight: normal;
              text-align: center;

              b {
                font-weight: bold;
                font-size: 24px;
              }
            }
          }
        }
      }

      .expenseLog {
        color: #666666;

        &:hover {
          color: #0047FF;

          i {
            color: #0047FF;
          }
        }

        i {
          font-size: 24px;
          color: #333;
          margin-top: 1px;
        }
      }
    }

    .userSet {
      margin: 0;
      padding: 16px;

      .userTitle {
        font-weight: bold;
        font-size: 14px;
        color: #000;
        margin-bottom: 16px;
      }

      .serviceSet {
        overflow: hidden;

        .package {
          border-radius: 16px;

        }
      }
    }

    .adBanner {
      margin: 16px 0 0 0;
      box-shadow: none;
      border-radius: 36px;
      background: none;
      flex: 1;

      img {
        height: 100%;
        width: 100%;
        border-radius: 16px;
      }
    }
  }
}


@media screen and (min-width: 1742px) {
  .main_home {
    .main_right {
      .cardTop {
      }


      .userSet {
        .serviceSet {
          .serviceItem {
            .maxScreen {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
            }

            .minScreen {
              display: none;
            }
          }
        }
      }
    }
  }

}

@media screen and (max-width: 1742px) {
  .main_home {
    .main_left {
      .topInfo {

        .cardList {

          .cardItem {
            padding: 20px 8px;

            .cardTop {

              .cardLeft {
              }

              .cardRight {

                .cardTitle {

                }

                .cardNum {

                }
              }
            }

            .cardBtn {
              div {
                font-size: 12px;
                padding: 6px 8%;
                //width: 91px;

                &:nth-child(2) {
                  margin-left: 5%;
                }
              }
            }

            .layer-wrap {
              width: 100% !important;

              dl {

                dt {

                  p {
                    font-size: 12px;
                  }
                }

                dd {
                  img {

                  }
                }
              }

            }
          }
        }
      }

    }

    .main_right {
      .cardTop {
        .avatarMax {
          display: none;
        }

        .avatar {
          display: flex;
          justify-content: flex-start;
          flex-direction: row;

          .loginName {
            margin-left: 12px;

            .phone {
              margin-top: 0;
              text-align: left;
            }

            .lawyerClass {
              justify-content: flex-start;


            }


          }

        }

        .expense {
          flex-direction: column;
          margin-top: 24px;

          .childEls {
            display: flex;
            flex-direction: column;

            .balance {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 12px;

              &:nth-child(3) {
                margin-bottom: 0px;
              }
            }
          }

          .btnBuy {
            padding: 8px 47px;
            margin-top: 8px;
          }
        }
      }

      /deep/ .userSet {
        .serviceSet {
          overflow: hidden;
          display: flex;
          justify-content: space-between;
          flex-direction: column;

          ul {
            flex-direction: column;
min-height: 247px;
            li {
              margin-bottom: 10px;
            }
          }
        }
      }

      .adBanner {

        img {
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}

/*最外层透明*/
/deep/ .el-table,
/deep/ .el-table__expanded-cell {
  background: rgba(255, 255, 255, 0.7) !important;
}

/* 表格内背景颜色 */
/deep/ .el-table th,
/deep/ .el-table tr,
/deep/ .el-table td {
  background: rgba(255, 255, 255, 0.7) !important;
  border: 0; //去除表格
}

/*去除底边框*/
/deep/ .el-table td.el-table__cell {
  border: 0;
}

/deep/ .el-table th.el-table__cell.is-leaf {
  border: 0;
}

/*去除底部灰条.el-table::before*/
/deep/ .el-table::before {
  display: none;
}
</style>